const { VITE_ENV: ENV = 'development' } = import.meta.env;

export default function env(key) {
  return import.meta.env[`VITE_${ENV.toUpperCase()}_${key}`];
};
